import {} from "multitool-sdk-core";
export class BrowserBlobStorageAdapter {
    async readBinary(key) {
        return (await fetch(key)).blob();
    }
    async readJSON(key) {
        const resp = await fetch(key);
        const blob = await resp.blob();
        const text = await blob.text();
        return JSON.parse(text);
    }
    async writeBinary({ body }) {
        const url = URL.createObjectURL(body);
        return { id: url };
    }
    async writeJSON({ body }) {
        const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        return { id: url };
    }
}
//# sourceMappingURL=BrowserBlobStorageAdapter.js.map